import { resetUpdatedBikeStatus } from "features/bikeFleet/slice/bikeFleetSlice"

interface ActionType {
	type: string
	payload: any
}

// Listener action middleware for reset bike status
export const bikeFleetMiddleware = (store) => (next) => (action: ActionType) => {
	next(action)
	//Array of action stringify
	const actionsList: string[] = [
		"setSearchBikeFleet",
		"getFilteredBikeFleet",
		"setToggleCheckedByCodeFnucy",
		"setToggleCheckedAll",
		"updateBike/pending",
	]
	const prefixActions = "bikeFleet/"
	const actionType = action.type?.replace(prefixActions, "")

	if (actionsList.includes(actionType)) {
		if (!action?.payload?.noChangeStatusUpdatedMessage) store.dispatch(resetUpdatedBikeStatus())
	}
	return action
}
